import { ApiConcept } from 'types/swagger/clarifai-api';
import { postConcept } from 'api-proxy/external/postConcept';

type GetOrCreateValidAiConceptProps = {
  apiAiConcept: ApiConcept | undefined;
  request: {
    userOrOrgId: string;
    appId: string;
  };
  aiConcept: {
    id: string;
    name: string;
    appId: string;
    userId: string;
  };
};

export const getOrCreateValidAiConcept = async ({
  apiAiConcept,
  request,
  aiConcept,
}: GetOrCreateValidAiConceptProps): Promise<ApiConcept | undefined> => {
  if (apiAiConcept) {
    return apiAiConcept;
  } else {
    const newAiConcept = await postConcept({
      request,
      concept: {
        id: aiConcept.id,
        name: aiConcept.name,
        user_id: aiConcept.userId,
        app_id: aiConcept.appId,
      },
    });
    if (newAiConcept) {
      return newAiConcept;
    }
  }
  return undefined;
};
